var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.547 1.616-.342.039c-1.533.179-3.074 1.004-4.053 2.171-.822.98-1.297 2.022-1.49 3.267-.066.429-.066 1.385 0 1.814.132.85.428 1.683.844 2.373 1.007 1.668 2.64 2.757 4.587 3.058.429.066 1.385.066 1.814 0a6.56 6.56 0 0 0 3.24-1.466 6.464 6.464 0 0 0 2.075-3.379c.129-.526.163-.845.163-1.493 0-.443-.012-.68-.047-.907-.312-2.014-1.478-3.705-3.232-4.683a6.408 6.408 0 0 0-2.199-.743c-.267-.04-1.163-.074-1.36-.051m1.368 1.062c1.137.214 2.112.721 2.899 1.508.791.791 1.292 1.756 1.511 2.913.067.354.067 1.448 0 1.802a5.53 5.53 0 0 1-.324 1.12 5.404 5.404 0 0 1-3.285 3.097 5.384 5.384 0 0 1-5.53-1.304c-.791-.791-1.292-1.756-1.511-2.913-.067-.354-.067-1.448 0-1.802.219-1.157.72-2.123 1.511-2.913a5.412 5.412 0 0 1 3.147-1.545c.278-.038 1.309-.014 1.582.037M7.803 5.26a.393.393 0 0 0 .156.733c.421.048.607-.513.242-.727a.362.362 0 0 0-.398-.006m0 2c-.212.122-.203.033-.203 1.936 0 1.867-.005 1.806.17 1.931a.456.456 0 0 0 .46 0c.175-.125.17-.064.17-1.927 0-1.898.009-1.812-.199-1.934a.362.362 0 0 0-.398-.006",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoLine);
export default __webpack_public_path__ + "static/media/icon-info-line.70397b0f166daa159ca698cdf050557f.svg";
export { ForwardRef as ReactComponent };